<template lang="pug">
    #home(:style="{'padding-top':paddingSize}",v-if="imgData&&imgList",:class="{'-scroll':$store.getters.getScroll}")
        frameBox(v-for="(item,index) in imgList" :key="'box'+index" :frameData="imgData[frameIndex(index)]" :index="index" :imgData="item")
        // 写真詳細
        photo-detail
</template>

<style lang="scss">
@import "../assets/scss/_common";

#home {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    transition: 0.3s;
    //padding-top: 20%;

    @media #{$pc} {
        padding-top: 0;
        flex-direction: column;
        align-items: center;
    }
}
</style>

<script>
// components
import frameBox from "@/components/FrameBox";
import photoDetail from "@/components/PhotoDetail";
// 枠データ
import frame from "@/assets/data/frame";
import axios from "axios";

export default {
    name: "home",
    components: {
        frameBox,
        photoDetail
    },
    mounted() {
        axios.get(this.accessUrl).then(res => {
            var count = 0;
            this.imgRaw = res.data.media.data;

            // ロゴ（リノデ紹介ページに飛ぶリンク）を何個おきに入れるか
            const logoInterval = 5;
            // 配列に格納するロゴデータの中身
            const logoData = {
                //media_url: "あああ",
                this_is_logo: true
            };

            for (let key of Object.keys(this.imgRaw)) {
                this.imgList.push(this.imgRaw[key]);
                count++;
                // logoInterval の個数おきにロゴ表示する用データも一緒に配列に格納
                if (count % logoInterval === 0) {
                    this.imgList.push(logoData);
                }
            }

            var list = this.imgList;

            for (var i = 0; i < 3; i++) {
                list = list.concat(this.imgList);
            }

            this.imgList = list;
        });
    },
    data() {
        return {
            display: false,
            displayImg: "",
            imgRaw: null,
            imgList: [],
            // 注意！確実に「文字列」で記載すること、数値だとエラーが出ます
            instaid: "17841412035893865",
            instatoken:
                "EAAL04n4zBgIBABY1ZBnC56jLasQndsN8Ys1Umr8VZB6TUabWA3h18ZC8sripvQsYqiZCWzXNfNrVKFQE3jsE9k7KWunPl0k9J8dW95YZANGMmKcopmATpnYB4ZCbQPBpKHIrg1hPtCcxsTdNQBhEXKXDe5OuZCYqPQZD"
        };
    },
    computed: {
        accessUrl() {
            return (
                "https://graph.facebook.com/v3.2/" +
                this.instaid +
                "?fields=name%2Cmedia.limit(999)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cusername%7D&access_token=" +
                this.instatoken
            );
        },
        aspect() {
            return this.$store.getters.getAspect;
        },
        height() {
            return this.aspect === "height"
                ? this.pc.heightRatio + "%"
                : "auto";
        },
        imgData() {
            if (this.$store.getters.getWidth > 980) {
                return frame.pc;
            } else {
                return frame.sp;
            }
        },
        paddingSize() {
            if (this.$store.getters.getWidth > 980) {
                return "0";
            }

            if (this.aspect === "height") {
                return this.$store.getters.getHeight * 0.12 + "px";
            } else {
                return "20%";
            }
        },
        // 枠の数
        frameLength() {
            return Object.keys(this.imgData).length;
        },
        scrollToggle() {
            return this.$store.getters.getScroll;
        }
    },
    methods: {
        frameIndex(index) {
            var count = Math.floor(index / this.frameLength);
            var result = index - this.frameLength * count;
            // console.log(this.frameLength);
            return result;
        }
    }
};
</script>
